import { createSvgComponent } from "../../icon/createSvgComponent";
import Check from "@core/__generated__/icon/figma/check.svg";
export default createSvgComponent(Check);